import { ElementType, IElement } from "../../../models/Element";
import { ElementHeaderType } from "../../utils";

export const defaultTwoRowData: string[] = ["Donderdag 18 april", "Deadline"];

export type TableTwoColumns = IElement & {
  header: string;
  header_type: ElementHeaderType;
  tableHeads: string[];
  dataTable: string[][];
  content: string;
};

export const defaultTableTwoColumns: TableTwoColumns = {
  id: 0,
  name: ElementType.TABLE_TWO_COLUMNS,
  header: "Gesprekstarieven VoIP",
  header_type: ElementHeaderType.H2,
  tableHeads: ["Datum", "Actie"],
  dataTable: [
    ["Donderdag 18 april", "Deadline"],
    ["Donderdag 18 april", "Deadline"],
  ],
  content:
    "Optionele tekst. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
};
